export default __webpack_public_path__ + "images/Audimatic_icon_small.png";